import LegalPage, { LSection, LList } from "../../components/legal/LegalPage";
import { LEGAL_IDENTITY, LEGAL_EMAIL } from "../../lib/legal";

export default function LegalNotice() {
  return (
    <LegalPage
      title="Aviso legal"
      subtitle="El presente Aviso Legal regula el acceso y la utilización del sitio web y de la plataforma Asset Passport."
      testid="legal-notice-page"
    >
      <LSection n="1" title="Titular del servicio">
        <dl className="grid sm:grid-cols-[160px_1fr] gap-y-2 gap-x-4">
          <dt className="font-medium text-zinc-900">Titular</dt>
          <dd>{LEGAL_IDENTITY.ownerName}</dd>
          <dt className="font-medium text-zinc-900">Nombre comercial</dt>
          <dd>{LEGAL_IDENTITY.commercialName}</dd>
          <dt className="font-medium text-zinc-900">País</dt>
          <dd>{LEGAL_IDENTITY.country}</dd>
          {LEGAL_EMAIL && (
            <>
              <dt className="font-medium text-zinc-900">Correo electrónico</dt>
              <dd>
                <a href={`mailto:${LEGAL_EMAIL}`} className="underline underline-offset-2 hover:text-zinc-900">
                  {LEGAL_EMAIL}
                </a>
              </dd>
            </>
          )}
          {LEGAL_IDENTITY.nif && (
            <>
              <dt className="font-medium text-zinc-900">NIF</dt>
              <dd>{LEGAL_IDENTITY.nif}</dd>
            </>
          )}
          {LEGAL_IDENTITY.address && (
            <>
              <dt className="font-medium text-zinc-900">Domicilio</dt>
              <dd>{LEGAL_IDENTITY.address}</dd>
            </>
          )}
        </dl>
      </LSection>

      <LSection n="2" title="Objeto">
        <p>
          Asset Passport es una plataforma digital dirigida a empresas y usuarios profesionales para
          organizar la información asociada a maquinaria y activos industriales, incluyendo su
          identificación, documentación, historial, fotografías, ubicaciones e información relacionada.
        </p>
        <p>Asset Passport no es:</p>
        <LList
          items={[
            "un sistema CMMS/GMAO",
            "un ERP",
            "un MES",
            "un sistema de control industrial",
            "un sistema de seguridad",
            "un sustituto de la documentación del fabricante",
            "un sustituto del juicio técnico profesional",
          ]}
        />
      </LSection>

      <LSection n="3" title="Condiciones de acceso">
        <p>El acceso al sitio web público es, con carácter general, gratuito.</p>
        <p>
          El acceso a la plataforma privada requiere una cuenta autorizada. En la actualidad, el
          servicio se ofrece a través de un piloto B2B controlado: las empresas solicitan acceso y
          Asset Passport crea las organizaciones aprobadas.
        </p>
        <p>
          Los usuarios deben proteger sus credenciales de acceso y utilizar el servicio de forma
          lícita y conforme a estas condiciones.
        </p>
      </LSection>

      <LSection n="4" title="Propiedad intelectual">
        <p>
          El software, la interfaz, la marca, el diseño y los contenidos originales de la plataforma
          Asset Passport están protegidos por la normativa de propiedad intelectual e industrial
          aplicable.
        </p>
        <p>
          Los contenidos del cliente siguen siendo propiedad del cliente o de sus legítimos
          titulares. El uso de Asset Passport no transfiere a Asset Passport la propiedad de la
          información del cliente.
        </p>
      </LSection>

      <LSection n="5" title="Responsabilidad">
        <p>
          Asset Passport proporciona una herramienta para organizar información. El cliente sigue
          siendo responsable de:
        </p>
        <LList
          items={[
            "la exactitud de la información introducida",
            "la legalidad de los contenidos subidos",
            "la documentación de sus máquinas",
            "las decisiones técnicas",
            "las decisiones de mantenimiento",
            "las obligaciones normativas que apliquen a sus equipos",
            "garantizar que solo personal autorizado utiliza el servicio",
          ]}
        />
        <p>Asset Passport no debe considerarse un sistema de control crítico para la seguridad.</p>
      </LSection>

      <LSection n="6" title="Enlaces externos">
        <p>
          Asset Passport puede contener enlaces o referencias a recursos de terceros. Asset Passport
          no controla los contenidos de terceros y no responde de servicios externos, salvo en los
          casos en que la ley lo exija.
        </p>
      </LSection>

      <LSection n="7" title="Legislación aplicable">
        <p>
          Este aviso legal se rige por la ley española, sin perjuicio de las normas imperativas que
          resulten de aplicación.
        </p>
        <p>
          Por tratarse de un servicio B2B, las controversias se someterán, cuando legalmente sea
          posible, a los juzgados y tribunales competentes correspondientes al establecimiento del
          prestador.
        </p>
      </LSection>
    </LegalPage>
  );
}
